import { $notifications, $users } from "@core/services/";
import buildPrivatePub from "@core/plugins/privatePub";

export default {
  namespaced: true,
  state: {
    layout: "Auth",
    chat: true,
    leftmenu: false,
    loader: {
      iframe: false,
    },
    newUpdateAvailable: false,
    iframe: {
      url: "",
    },
    drawer: {
      right: {
        show: false,
        request: "",
        tab: "",
        component: "m-notification-drawer",
        response: [],
        type: "",
      },
    },
    notifications: {
      unread: 0,
      data: [],
      loading: false,
      current_notification_id: null,
    },
    campaign_row: {
      id: null,
    },
    folder: {
      show: false,
      lock: false,
      id: null,
      type: "",
      ancestry: [],
      lastSavedValue: "",
      length: 0,
      externalElement: {
        id: null,
        type: "",
        name: "",
        refresh: false,
      },
      parent:null
    },
    snackbar: {
      title: "",
      show: false,
      message: "",
      type: "info",
      timeout: 6000,
      controller: "",
      id: null,
    },
    gridView: false,
    previousRoute: {}
  },
  getters: {
    layout: (state) => state.layout,
    chat: (state) => state.chat,
    leftmenu: (state) => state.leftmenu,
    loader: (state) => state.loader,
    drawer: (state) => state.drawer,
    notifications: (state) => state.notifications,
    folder: (state) => state.folder,
    snackbar: (state) => state.snackbar,
    iframe: (state) => state.iframe,
    "folder.externalElement": (state) => state.folder.externalElement,
    gridView: (state) => state.gridView,
    previousRoute: (state) => state.previousRoute,
  },
  mutations: {
    setPreviousRoute(state,data){
      state.previousRoute = data
    },
    "channel.signature": (state, value) => {
      var debounceRapidNotif;
      state.channelSignature = value;
      let notif = [];
      Object.entries(value).map((val) => {
        if (val[0].includes("notifications/alert")) {
          notif = val;
        }
      });
      var PrivatePub = buildPrivatePub(document);
      PrivatePub.sign({
        channel: notif[0],
        timestamp: notif[1].timestamp,
        signature: notif[1].signature,
        server: notif[1].server,
      });
      PrivatePub.subscribe(notif[0], (data, channel) => {
        var generateNotification = function () {
          // Let's check if the browser supports notifications
          if (!("Notification" in window)) {
            alert("This browser does not support desktop notification");
          }

          // Let's check whether notification permissions have already been granted
          else if (Notification.permission === "granted") {
            // If it's okay let's create a notification
            var notification = new Notification("Maropost", {
              icon: "/img/icons/apple-icon.png",
              body: data.message,
            });
          }

          // Otherwise, we need to ask the user for permission
          else if (Notification.permission !== "denied") {
            Notification.requestPermission().then(function (permission) {
              // If the user accepts, let's create a notification
              if (permission === "granted") {
                var notification = new Notification("Maropost", {
                  icon: "/img/icons/apple-icon.png",
                  body: data.message,
                });
              }
            });
          }

          let titleLength = document.title.split(")").length - 1;
          if (state.notifications.unread) {
            document.title =
              "(" +
              state.notifications.unread.toLocaleString() +
              ") " +
              document.title.split(")")[titleLength];
          } else {
            document.title = document.title.split(")")[titleLength];
          }
        };
        const notificationIndex = state.notifications.data.findIndex(
          (n) =>
            n.percent_complete < 100 && n.notifiable_id == data.notifiable_id
        );
        if (notificationIndex != -1) {
          state.notifications.data[notificationIndex].message = data.message;
          state.notifications.data[notificationIndex].is_unread = true;
          state.notifications.data[notificationIndex].show_download =
            data.show_download;
          state.notifications.data[notificationIndex].status = data.status;
          state.notifications.data[notificationIndex].percent_complete =
            data.percent_complete;
          state.notifications.data[notificationIndex].download_url =
            data.download_url;
          state.notifications.unread = state.notifications.data.filter(
            (n) => n.is_unread
          ).length;
          clearTimeout(debounceRapidNotif);
          debounceRapidNotif = setTimeout(() => {
            generateNotification();
          }, 5000);
        } else if (data.percent_complete != 100) {
          const notification_data = {
            account_id: data.account_id,
            created_at: data.notification_date,
            data: data.data,
            download_url: data.download_url,
            duration: data.duration,
            id: data.id,
            is_unread: true,
            message: data.message,
            notifable_type: data.notifable_type,
            percent_complete: data.percent_complete,
            show_download: data.show_download,
            status: data.status,
            notifiable_id: data.notifiable_id,
          };
          state.notifications.data.unshift(notification_data);
          state.notifications.unread++;
          generateNotification();
        }
        state.notifications.current_notification_id = data.notifiable_id;
      });
    },
    layout: (state, value) => {
      state.layout = value;
    },
    "iframe.url": (state, value) => {
      state.iframe.url = value;
    },
    gridView: (state, value) => {
      state.gridView = value;
    },
    leftmenu: (state, value) => {
      value = value !== true && value !== false ? !state.leftmenu : value;
      state.leftmenu = value;
    },
    chat: (state, value) => {
      state.chat = value;
    },
    folder:(state, value)=>{
      state.folder = value
    },
    "folder.id": (state, value) => {
      state.folder.id = value;
    },
    "folder.parent": (state, value) => {
      state.folder.parent = value; 
    },
    "folder.ancestry": (state, value) => {
      state.folder.ancestry = value;
    },
    "folder.length": (state, value) => {
      state.folder.length = value;
    },
    "folder.lastSavedValue": (state, value) => {
      state.folder.lastSavedValue = value;
    },
    "folder.show": (state, value) => {
      value = typeof value === "boolean" ? value : !state.folder.show;
      state.folder.show = value;
    },
    "folder.type": (state, value) => {
      state.folder.type = value;
    },
    "folder.lock": (state, value) => {
      state.folder.lock = value;
    },
    "folder.externalElement": (state, value) => {
      state.folder.externalElement = value;
    },
    "loader.iframe": (state, value) => {
      state.loader.iframe = value;
    },
    "drawer.right": (state, value) => {
      state.drawer.right = value;
    },
    "campaign_row.id": (state, value) => {
      state.campaign_row.id = value;
    },
    "drawer.right.toggle": (state, value) => {
      value =
        value !== true || value !== false ? !state.drawer.right.show : value;
      state.drawer.right.show = value;
    },
    'drawer.right.update':(state, values) =>{   
        state.drawer.right = {...state.drawer.right, ...values};
    },
    notifications: (state, value) => {
      state.notifications = value;
    },
    "notifications.reset": (state, value) => {
      state.notifications = {
        data: [],
        unread: 0,
        loading: false,
      };
    },
    "notifications.unread": (state, value) => {
      state.notifications.unread = value;
    },
    "notifications.data": (state, value) => {
      state.notifications.data = value;
    },
    "notifications.loading": (state, value) => {
      value = typeof value === "boolean" ? value : !state.notifications.loading;
      state.notifications.loading = value;
    },
    "snackbar.toggle": (state, value) => {
      value =
        value !== true || value !== false ? !state.drawer.right.show : value;
      state.snackbar.show = value;
    },
    "snackbar.message": (state, value) => {
      state.snackbar.message = value;
    },
    "snackbar.show": (state, value) => {
      state.snackbar.show = value;
    },
    updateAvailable: (state, value) => {
      state.newUpdateAvailable = value;
    },
    snackbar: (
      state,
      { show, message, timeout, type, controller, id, title }
    ) => {
      timeout = timeout || 6000;

      const value = {
        title: title || "",
        show: typeof show === "boolean" ? show : true,
        message: message || "",
        type: type || "",
        timeout: isNaN(timeout) ? 6000 : parseInt(timeout),
        controller: controller || "",
        id: id || null,
      };
      state.snackbar = value;
    },
    "snackbar.reset": (state, value) => {
      state.snackbar = {
        show: false,
        message: "",
        type: "info",
        timeout: 6000,
        controller: "",
        id: null,
      };
    },
  },
  actions: {
    snackbar({ commit }, [title, message, type]) {
      commit("snackbar", title, message, type);
    },

    "snackbar.reset"({ commit }) {
      commit("snackbar.reset");
    },
    getNotifications({ commit }) {
      commit("notifications", {
        unread: 0,
        data: [],
        loading: true,
        current_notification_id: null,
      });
      $notifications
        .getList({
          params: {
            page: 1,
            per_page: 10,
          },
        })
        .then((response) => {
          commit("notifications", {
            data: response.data.notifications,
            unread: response.data.meta.unread_count,
            loading: false,
            current_notification_id: response.data.notifications.length
              ? response.data.notifications[0].notifiable_id
              : null,
          });
          let titleLength = document.title.split(")").length - 1;
          if (response.data.meta.unread_count) {
            document.title =
              "(" +
              response.data.meta.unread_count.toLocaleString() +
              ") " +
              document.title.split(")")[titleLength];
          } else {
            document.title = document.title.split(")")[titleLength];
          }
        });
    },
    getChannelSignature({ commit }) {
      $users.getChannelSignature().then((response) => {
        commit("channel.signature", response.data.data);
      });
    },
    setFolderIdFromBreadcrumb(context, event){
      const item = context.state.folder.ancestry.filter(
        (element) => {
          if (event.target.innerHTML === element.text) return element.id
        }
      )
      if(item.length){
        context.commit('folder.id',parseInt(item[0].id, 0))
        context.commit('setFolderId',parseInt(item[0].id, 0), { root: true})
      } else {
        context.commit('folder.id',null)
        context.commit('setFolderId',null, { root: true})
      }
    }
  },
};
